import React, { useContext, useState } from 'react';
import { useIntl } from 'react-intl';
import { useQueryClient } from '@tanstack/react-query';
import { useMount } from 'ahooks';
import Alert from 'Common/Components/Alert';
import { useLocation, useNavigate } from 'react-router';
import { LocaleContext } from 'utils/OwnIntlProvider';
import { useAccountLogin } from 'Account/hooks/auth';
import FormWrapper from './views/FormWrapper';
import Title from './views/Title';
import LoginForm, { LoginFormValues } from './views/LoginForm';
import SwitchLangButton from './views/SwitchLangButton';
import SupportText from './views/SupportText';

const Login = () => {
  const intl = useIntl();
  const queryClient = useQueryClient();
  const location = useLocation();
  const navigate = useNavigate();
  const context = useContext(LocaleContext);
  const accountLoginMutation = useAccountLogin();
  const [hasError, setHasError] = useState(false);

  useMount(() => {
    queryClient.removeQueries();
  });

  const navigateToPin = () =>
    navigate('/pin', { replace: false, state: location.state });

  const onLogin = (values: LoginFormValues) => {
    accountLoginMutation.mutate(
      {
        email: values.email,
        password: values.password,
      },
      {
        onSuccess: ({ token, error }) => {
          if (token) {
            navigateToPin();
          } else if (error) {
            setHasError(true);
          }
        },
      }
    );
  };

  const switchLanguage = (lng: string) => {
    localStorage.setItem('locale', lng);
    context.selectLanguage(lng);
  };

  return (
    <>
      <FormWrapper>
        <Title />
        {hasError && (
          <Alert
            title={intl.formatMessage({
              defaultMessage:
                'Please try again. You have entered an invalid email or password',
            })}
            type="error"
          />
        )}
        <LoginForm onLogin={onLogin} />
      </FormWrapper>
      <SupportText css="margin-top: 10px" />
      <SwitchLangButton
        selectedLang={context.locale}
        changeLang={switchLanguage}
      />
    </>
  );
};

export default Login;
